<template>
  <div id="adminSelenaViews">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">{{ admin }}</li>
      <li class="breadcrumb-item">Catalogo</li>
      <li class="breadcrumb-item active">
        <router-link :to="url">Albero</router-link>
      </li>
    </ol>
    <div class="container-fluid card-title-admin">
      <h1>Albero</h1>
    </div>
    <div class="container-fluid">
      <div class="card">
        <div class="tab-content noborder">
          <div class="tab-pane nopadding active" id="tabTable" role="tabpanel">
           
            <div class="card-body" id="card-body-tree" style="padding-top:0px;padding-bottom:15px;padding-right: 15px;padding-left: 15px;">
              <div class="row">
                <div class="col-sm-12 col-md-6" style="padding-top: 15px" >
                  <h1 style="font-size: 30px; font-weight: lighter; color: rgb(48, 60, 84);margin-bottom:15px;">Catalogo generale <a class="btn btn-primary button" @click="reloadPage" style="color:#fff;cursor:pointer;"><i class="fa fa-refresh" style="font-size:15px; cursor:pointer;"></i> Aggiorna</a></h1>
                  <div style="margin-left:-20px;">
                  <TreeCategoriesMap :listCategories="listTreeCategories" ></TreeCategoriesMap>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6" style="padding-top: 15px" >
                  <h1 style="font-size: 30px; font-weight: lighter; color: rgb(48, 60, 84);">Articoli senza categoria <span style="font-style: italic;font-size: 14px;font-weight: bold;">(totale: {{numberItemWithNoCategory}})</span></h1>
                  <div class="row" style="margin-bottom:5px;">
                    <div class="col-10">
                      <input type="text" id="searchItems" name="searchItems" class="form-control" placeholder="Inserire una chiave di ricerca per codice o descrizione o brand">
                    </div>
                    <div class="col-2">
                      <a class="btn btn-primary button" @click="searchItems();" style="color:#fff;cursor:pointer;">Cerca</a>
                    </div>
                  </div>
                  <div v-if="listItemWithNoCategory.length > 0" class="container-no-categories-item">
                    <div class="row" v-for="listItem in listItemWithNoCategory" v-bind:key="listItem.id">
                      <div class="col-12 align-self-center">
                        <i class="fa fa-trash" title="Clicca per eliminare l'articolo" style="color:rgb(212, 73, 80);cursor:pointer;margin-right:10px;font-size:20px;" @click="deleteItem(listItem.id, true)"></i>
                        <router-link :to="'/admin/crm/Items?id=' + listItem.id" target='_blank'><i class="fa fa-pencil-square-o" title="Clicca per modificare i dati" style="cursor:pointer;margin-right:15px;font-size:20px;color:#222;position: relative;top: 2px;"></i></router-link>
                        
                        <input style="cursor:pointer;margin-right:10px;" type="checkbox" :data-id-item="listItem.id" :id="'item-check-active' + listItem.id" :data-description-item="listItem.description" @change="activeItemWithoutCategoryFn(listItem.id)">
                        
                        <label>{{ listItem.code }} - {{ listItem.description }} {{ listItem.codeProducer }}</label>
                      </div>
                    </div>
                  </div>
                  <div v-else class="text-center">
                    <h4>Nessun articolo presente</h4>
                  </div>
                  <div style="border-top:3px solid #ededed;box-shadow:0px -5px 5px -5px rgb(0 0 0 / 20%);" v-if="listItemWithNoCategory.length > 0 && activeItemWithoutCategoryDescription.length > 0">
                    <div class="row" style="margin-top:15px;">
                      <div class="col-12">
                        <h5 style="margin-bottom:5px;">Associazione articoli senza categoria</h5>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <hr>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-5">
                        <div class="row" v-for="activeItemWithoutCategoryDescriptions in activeItemWithoutCategoryDescription" v-bind:key="activeItemWithoutCategoryDescriptions">
                          <div class="col-md-12">
                            <label style="margin-bottom:0px;font-size:13px !important;">- {{activeItemWithoutCategoryDescriptions}}</label>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-5">
                        <input class="form-control" id="category_code" name="category_code" placeholder="Codice categoria">
                      </div>
                      <div class="col-md-2 text-right">
                        <a class="btn btn-primary button" style="color:#fff;cursor:pointer;" @click="insertItemCategory()">Associa</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div> 
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal allegati -->
    <div class="modal" id="modalGestioneAllegati" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" >
      <div class="modal-dialo popup" role="document">
        <div class="modal-content modal">
          <div class="modal-header text-center">
            <div class="row" style="width:100%;">
              <div class="col-4 text-left"> 
                <h2 style="color:#303C53;font-weight:bold;text-transform:uppercase;">Gestione immagine</h2>
              </div>
            </div>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="md-form mb-5">
              <div class="row div-row-img-item" style="border-bottom: 1px solid #c8ced3;margin-bottom:15px;">
                <div class="col-9">
                  <div class="row div-row-img-item">
                    <div class="col-5 align-self-center">
                      <label>Immagine</label><br />
                      <!-- <button class="btn btn-primary" > SELEZIONA </button>@click="selectImageExist(itemImages.id, true)" -->
                      <label class="label-name">{{ modalAllegati.img }}</label>
                    </div>
                    <div class="col-2 align-self-center">
                      <label>Anteprima</label><br /><br>
                      <a class="img" target="_blank" :href="modalAllegati.img"><img :src="modalAllegati.img" /></a>
                    </div>
                    <div class="col-1 align-self-center text-right">
                      <i class="fa fa-trash btn btn-danger delete" style="color:#fff; margin-left: 3px;" @click="deleteImage(true, modalAllegati.id)"></i>
                    </div>
                  </div>
                </div>
                <div class="col-3 align-self-center">
                  <input type="hidden" name="id-item-document" id="id-item-document" :value="modalAllegati.id">
                  <label for="imgPrincipal" class="custom-file-upload" v-cloak @drop.prevent="onChangeImagePrincipal" @dragover.prevent >
                    SFOGLIA / UPLOAD AREA
                  </label>
                  <input type="file" id="imgPrincipal" name="imgPrincipal" @change="onChangeImagePrincipal"/>
                </div>
              </div>
              <div v-if="modalAllegati.itemAttachmentType.length > 0">
                <div class="row" >
                  <div class="col-12">
                    <h2 style="color:#303C53;font-weight:bold;text-transform:uppercase;">Gestione allegati</h2>
                  </div>
                </div>
                <div class="row" >
                  <div class="col-12">
                    <div class="accordion" id="accordionExample">
                      <div class="card" style="margin-bottom:0px;" v-for="itemAttachmentType in modalAllegati.itemAttachmentType" v-bind:key="itemAttachmentType.id">
                        <div class="card-header" :id="'headingOne' + itemAttachmentType.id">
                          <h2 class="mb-0">
                            <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse" :data-target="'#collapseOne' + itemAttachmentType.id" aria-expanded="true" :aria-controls="'collapseOne' + itemAttachmentType.id">
                              {{ itemAttachmentType.description }} (File presenti: {{itemAttachmentType.count}})
                            </button>
                          </h2>
                        </div>

                        <div :id="'collapseOne' + itemAttachmentType.id" class="collapse" :aria-labelledby="'headingOne' + itemAttachmentType.id" data-parent="#accordionExample">
                          <div class="card-body">
                            <div class="row">
                              <div class="col-12">
                                  <h6 style="color:#303C53;font-weight:bold;text-transform:uppercase;">Nuovo allegato</h6>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-4">
                                <!-- upload area -->
                                <div class="row">
                                  <div class="col-12">
                                    <label id="move-file" v-cloak @drop.prevent="handleFileInput" @dragover.prevent class="custom-file-upload" style="padding: 50px;">
                                      <input type="hidden" :id="'file' + itemAttachmentType.id" :name="'file' + itemAttachmentType.id" v-model="newAttachmentFile">
                                      <input type="hidden" :id="'fileBase64' + itemAttachmentType.id" :name="'fileBase64' + itemAttachmentType.id" v-model="newAttachmentFileBase64">
                                      <input class="imgAttachmentAgg" :data-id="itemAttachmentType.id" :id="'imgAttachmentAgg' + itemAttachmentType.id" type="file"  name="file-input" multiple="True" @change="handleFileInput" />
                                      SFOGLIA/UPLOAD AREA
                                    </label>
                                  </div>
                                </div>
                                <!-- end upload area -->
                              </div>
                              <div class="col-8">
                                <!-- detail area -->
                                <div class="row">
                                  <div class="col-12">
                                    <label style="margin-bottom: 0.2rem;">Url</label>
                                    <input type="text" :id="'url' + itemAttachmentType.id" :name="'url' + itemAttachmentType.id"  class="form-control"  v-model="newAttachmentFileUrl">
                                  </div>
                                </div>
                                <div class="row" style="margin-top: 5px;">
                                  <div class="col-10 align-self-center">
                                    <label style="margin-bottom: 0.2rem;">Descrizione</label>
                                    <input type="text" :id="'description' + itemAttachmentType.id" :name="'description' + itemAttachmentType.id"  class="form-control" v-model="newAttachmentFileDescription">
                                  </div>
                                  <div class="col-2 align-self-center text-right">
                                    <br>
                                    <button class="btn btn-success" @click="saveNewItemTypeAttachment(itemAttachmentType.id, modalAllegati.id)"><i class="fa fa-save" title="Visualizza il dettaglio"></i> Salva</button>
                                  </div>
                                </div>
                                <!-- end detail area -->
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-12">
                                  <h6 style="color:#303C53;font-weight:bold;text-transform:uppercase;">Allegati presenti</h6>
                              </div>
                            </div>
                            <div v-if="itemAttachmentType.itemAttachmentFile.length > 0">
                              <div class="row" v-for="itemAttachmentFile in itemAttachmentType.itemAttachmentFile" v-bind:key="itemAttachmentFile.id">
                                <div class="col-1 align-self-center">
                                  <i class="fa fa-trash btn btn-danger delete" style="color: rgb(255, 255, 255); margin-left: 3px;cursor:pointer;" @click="deleteItemAttachamentFile(itemAttachmentFile.id, modalAllegati.id)"></i>
                                </div>
                                <div class="col-11 align-self-center">
                                  <h5>{{ itemAttachmentFile.description }} </h5>
                                </div>
                              </div>
                            </div>
                            <div v-else>
                              <h5>Nessun file presente</h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end modal allegati -->
  </div>
</template>

<script>
import BootstrapTable from "@/components/BootstrapTable.vue";
import PageDetail from "@/components/PageDetail.vue";
import TreeCategoriesMap from "@/components/TreeCategoriesMap.vue";
export default {
  name: "adminSelenaViews",
  components: {
    BootstrapTable,
    PageDetail,
    TreeCategoriesMap
  },
  data: function() {
    return {
      add: dictionaryHelpers.getDictionary("Add"),
      admin: dictionaryHelpers.getDictionary("Admin"),
      cancel: dictionaryHelpers.getDictionary("Cancel"),
      save: dictionaryHelpers.getDictionary("Save"),
      setting: dictionaryHelpers.getDictionary("Setting"),
      language: dictionaryHelpers.getDictionary("Language"),
      updateCompleted: dictionaryHelpers.getDictionary('UpdateCompleted'),
      insertCompleted: dictionaryHelpers.getDictionary('InsertCompleted'),
      defaultLanguageOptions: [],
      detailNationConfiguration: [],
      tableNationResult: [],
      detailNationData: {},

      newAttachmentFile: '',
      newAttachmentFileBase64: '',
      newAttachmentFileDescription: '',
      newAttachmentFileUrl: '',


      modalAllegati: {itemAttachmentType:[]},
      tableConfiguration: [],
      listTreeCategories: [],
      numberItemWithNoCategory: 0,
      listItemWithNoCategory: [],
      arrayListCategoriesDetail: [],
      activeItemWithoutCategory: [],
      activeItemWithoutCategoryDescription: [],
      rowIdSelected:0,
      pageValueSelected: {
        id: 0,
        languagePageSetting: { content: null }
      },
      tableData: [],
      disableButton: true,
      url: window.location.pathname
    };
  },
  created() {
    var adminCrmItems = this;

    spinnerHelpers.show();
    adminCrmItems.defaultLanguageOptions = {
      id: storageData.sIdLanguage(),
      text: storageData.sDescriptionLanguage()
    };

    adminCrmItems.loadTable(); 
    adminCrmItems.loadTableItemNoCategory(); 
  },
  methods: {
    reloadPage() {
      window.location.reload();
    },
    loadTable(ln) {
      var adminCrmItems = this;
      var ln = storageData.sIdLanguage();
      if (!functionHelpers.isValued(ln)) {
        ln = storageData.sIdLanguage();
      }
      adminCrmItems.rowIdSelected = 1;

      categoriesServices.getAllListNavigationFather(ln, adminCrmItems.rowIdSelected, function (result) {
        adminCrmItems.listTreeCategories = result.data;
        spinnerHelpers.hide();
      });
    },
    loadTableItemNoCategory(){
      var adminCrmItems = this;
      var ln = storageData.sIdLanguage();
      if (!functionHelpers.isValued(ln)) {
        ln = storageData.sIdLanguage();
      }
      adminCrmItems.rowIdSelected = 1;

      var data = {
        ln: ln,
        search: $('#searchItems').val()
      }

      itemServices.getAllItemsWithoutCategory(data, function (result) {
        adminCrmItems.listItemWithNoCategory = result.data;
        adminCrmItems.numberItemWithNoCategory = result.data.length;
        setTimeout(function() {
          $('.container-no-categories-item').css('max-height', window.innerHeight - 375 + 'px');
        }, 1000);
      });
    },
    activeItemWithoutCategoryFn(id){
      var adminCrmItems = this;
      if ($('#item-check-active' + id).is(":checked")) {
        adminCrmItems.activeItemWithoutCategory.push(id);
        adminCrmItems.activeItemWithoutCategoryDescription.push($('#item-check-active' + id).attr('data-description-item'));
      } else {
        var index = adminCrmItems.activeItemWithoutCategory.indexOf(id);
        if (index > -1) {
          adminCrmItems.activeItemWithoutCategory.splice(index, 1);
        }

        var indexDesc = adminCrmItems.activeItemWithoutCategoryDescription.indexOf($('#item-check-active' + id).attr('data-description-item'));
        if (indexDesc > -1) {
          adminCrmItems.activeItemWithoutCategoryDescription.splice(indexDesc, 1);
        }
      }
    },
    insertItemCategory(){
      console.log('ok');
      var adminCrmItems = this;
      if($('#category_code').val()==''){
        notificationHelpers.error("Attenzione non è stato inserito nessun codice categoria!");
      }else{
        var data = {
          codeCategory: $('#category_code').val(),
          items: adminCrmItems.activeItemWithoutCategory
        }

        categoriesServices.insertCategoryItemWithoutCategory(data, function (result) {
          if(result.message == ''){
            adminCrmItems.activeItemWithoutCategory = [];
            adminCrmItems.activeItemWithoutCategoryDescription = [];
            
            var ln = storageData.sIdLanguage();
            if (!functionHelpers.isValued(ln)) {
              ln = storageData.sIdLanguage();
            }
            var dataUpdateList = {
              ln: ln,
              search: $('#searchItems').val()
            }

            itemServices.getAllItemsWithoutCategory(dataUpdateList, function (resultUpdateList) {
              adminCrmItems.listItemWithNoCategory = resultUpdateList.data;
              adminCrmItems.numberItemWithNoCategory = resultUpdateList.data.length;
              setTimeout(function() {
                $('.container-no-categories-item').css('max-height', window.innerHeight - 375 + 'px');
              }, 1000);
            });

            notificationHelpers.success("Articoli associati correttamente");
          }else{
            notificationHelpers.error(result.message);
          }
        });
      }
    },
    searchItems(){
      this.loadTableItemNoCategory();
    },
    checkCategoriesClick(id, checkedCategories) {
      var adminCrmItems = this;

      var data = {
        idCategories: id,
        idCategoriesSelected: adminCrmItems.rowIdSelected,
      };

      if (checkedCategories) {
        categoriesServices.insertCategoriesFather(data, function (result) {
          adminCrmItems.loadDetailListCategories();
          notificationHelpers.success("Categoria associata correttamente");
        });
      } else {
        categoriesServices.deleteCategoriesFather(id,adminCrmItems.rowIdSelected,function (result) {
          adminCrmItems.loadDetailListCategories();
          notificationHelpers.success("Categoria rimossa correttamente");
        });
      }
    },
    changeOrderCategoryFatherUp(id, idItem, order, isCategories){
      var adminCrmCategories = this;
      var ln = adminCrmCategories.languages;
      var newOrd = parseInt(order) - 10;
      if(order < 0){
        newOrd = 0;
      }

      if(isCategories){
        var data = {
          'id': id,
          'order': newOrd
        }

        categoriesServices.updateOrderCategoriesTable(data, function (result) {
          notificationHelpers.success("Aggiornamento avvenuto correttamente");
          spinnerHelpers.show();
          if (!functionHelpers.isValued(ln)) {
            ln = storageData.sIdLanguage();
          }
          adminCrmCategories.loadTable(ln);
        });
      }else{
        var data = {
          'id': idItem,
          'category_id': id,
          'order': newOrd
        }

        itemServices.updateOrderCategoriesItemTable(data, function (result) {
          notificationHelpers.success("Aggiornamento avvenuto correttamente");
          spinnerHelpers.show();
          if (!functionHelpers.isValued(ln)) {
            ln = storageData.sIdLanguage();
          }

          adminCrmCategories.loadTable(ln);
        });
      }
    },
    changeOrderCategoryFatherDown(id, idItem, order, isCategories){
      var adminCrmCategories = this;
      var ln = adminCrmCategories.languages;
      var newOrd = parseInt(order) + 10;

      if(isCategories){
        var data = {
          'id': id,
          'order': newOrd
        }
        categoriesServices.updateOrderCategoriesTable(data, function (result) {
          notificationHelpers.success("Aggiornamento avvenuto correttamente");
          spinnerHelpers.show();
          if (!functionHelpers.isValued(ln)) {
            ln = storageData.sIdLanguage();
          }
          adminCrmCategories.loadTable(ln);
        });
      }else{
        var data = {
          'id': idItem,
          'category_id': id,
          'order': newOrd
        }

        itemServices.updateOrderCategoriesItemTable(data, function (result) {
          notificationHelpers.success("Aggiornamento avvenuto correttamente");
          spinnerHelpers.show();
          if (!functionHelpers.isValued(ln)) {
            ln = storageData.sIdLanguage();
          }
          adminCrmCategories.loadTable(ln);
        });
      }
    },
    viewDetailDocumentItemFather(id, idItem, order, isCategories){
      var adminPopupAllegati = this;
      /* chiamata web api per estrazione:
      - immagine 
      - documenti allegati all'articolo
      */

      itemServices.getDocumentInformationById(idItem, function (result) {
        /* visualizzazione informazioni popup */
        console.log(result);
        adminPopupAllegati.modalAllegati = result.data;
        $("#modalGestioneAllegati").modal("show");
      });
    },
    changeOnlineCategory(id, online, isCategories){
      var adminCrmItems = this;
      if(isCategories){
        var data = {
          idCategories: id,
        };
        categoriesServices.updateOnlineCategories(data, function (result) {
          notificationHelpers.success("Aggiornamento avvenuto correttamente");
          adminCrmItems.updateOnlineInfoLive(id, online, isCategories, adminCrmItems.listTreeCategories);
        });
      }else{
        var data = {
          idItem: id,
        };
        itemServices.updateOnlineItem(data, function (result) {
          notificationHelpers.success("Aggiornamento avvenuto correttamente");
          adminCrmItems.updateOnlineInfoLive(id, online, isCategories, adminCrmItems.listTreeCategories);
        });
      }
    },
    updateOnlineInfoLive(id, online, isCategories, listTreeCategories){
      var adminCrmItems = this;
      if(isCategories){
        if(listTreeCategories.length > 0){
          for(var i = 0; i < listTreeCategories.length; i++){
            if(listTreeCategories[i].id == id){
              listTreeCategories[i].online = !online;
            }else{
              if(listTreeCategories[i].categoriesList.length>0){
                adminCrmItems.updateOnlineInfoLive(id, online, isCategories, listTreeCategories[i].categoriesList);
              }
            }
          }
        }
      }else{
        if(listTreeCategories.length > 0){
          for(var i = 0; i < listTreeCategories.length; i++){
            if(listTreeCategories[i].itemsList.length > 0){
              for(var j = 0; j < listTreeCategories[i].itemsList.length; j++){
                if(listTreeCategories[i].itemsList[j].item_id == id){
                  listTreeCategories[i].itemsList[j].online = !online;
                }else{
                  if(listTreeCategories[i].categoriesList.length>0){
                    adminCrmItems.updateOnlineInfoLive(id, online, isCategories, listTreeCategories[i].categoriesList);
                  }
                }
              }
            }
          }
        }
      }
    },
    deleteItem(id, isWithoutCategory){
      var adminCrmItems = this;
      var ln = storageData.sIdLanguage();
      if (confirm("Sei sicuro di voler eliminare?")) {
        spinnerHelpers.show();
        itemServices.del(id, function () {
          notificationHelpers.success(dictionaryHelpers.getDictionary("DeleteCompleted"));
          
          if(isWithoutCategory){
            adminCrmItems.loadTableItemNoCategory();
          }else{
            adminCrmCategories.loadTable(ln);
          }

        });
      }
    },

    /* popup documenti */
    deleteImage(isPrincipalImage, id) {
      var adminCrmItems = this;
      if (confirm("Sei sicuro di voler eliminare l'associazione dell'immagine?")) {
        if (isPrincipalImage) {
          //update imgName = '' in items.imgName by id
          var data = {
            idItem: id,
            imgName: "",
            imgBase64: "",
          };

          itemServices.updateImageName(data, function (result) {
            //adminCrmItems.loadItemImages();
            notificationHelpers.success("Eliminazione avvenuta correttamente");
          });
        }
      }
    },
    onChangeImagePrincipal(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImagePrincipal(e.target.id, files[0].name, files[0]);
    },
    createImagePrincipal(id, name, file) {
      var adminCrmItems = this;
      var reader = new FileReader();
      var vm = this;

      reader.onload = (e) => {
        var data = {
          idItem: $('#id-item-document').val(),
          imgName: name,
          imgBase64: e.target.result,
        };

        itemServices.updateImageName(data, function (result) {
          //adminCrmItems.loadItemImages();
          console.log(result);
          adminCrmItems.modalAllegati.img = result.message;
          notificationHelpers.success("Immagine principale inserita con successo");
        });
      };

      reader.readAsDataURL(file);
    },
    handleFileInput(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      for (var i = 0; i < files.length; i++) {
        this.createAttachmentAgg(e.target.id, files[i].name, files[i]);
      }
    },
    createAttachmentAgg(id, name, file) {
      var idEl = id;
      var adminItemAttachmentFile = this;
      var idNum = idEl.replace("imgAttachmentAgg", "");
      var reader = new FileReader();
      reader.onload = (e) => {
        adminItemAttachmentFile.newAttachmentFile = name;
        adminItemAttachmentFile.newAttachmentFileBase64 = e.target.result;
        adminItemAttachmentFile.newAttachmentFileDescription = name;
        adminItemAttachmentFile.newAttachmentFileUrl = '/api/storage/files/' + name;
      };
      reader.readAsDataURL(file);
    },
    saveNewItemTypeAttachment(idType, idItem){
      var adminItemAttachmentFile = this;
      var data = {
        idItem: idItem,
        idType: idType,
        newAttachmentFile: adminItemAttachmentFile.newAttachmentFile,
        newAttachmentFileBase64: adminItemAttachmentFile.newAttachmentFileBase64,
        newAttachmentFileDescription: adminItemAttachmentFile.newAttachmentFileDescription,
        newAttachmentFileUrl: adminItemAttachmentFile.newAttachmentFileUrl,
      };

      itemAttachmentFileServices.insertFromAlbero(data, function (result) {
        for(var i = 0; i<adminItemAttachmentFile.modalAllegati.itemAttachmentType.length;i++){
          if(adminItemAttachmentFile.modalAllegati.itemAttachmentType[i].id == idType){
            adminItemAttachmentFile.modalAllegati.itemAttachmentType[i].itemAttachmentFile.push(result.data);
          }
        }
        notificationHelpers.success('Inserimento avvenuto con successo!');
      })


    },
    deleteItemAttachamentFile(id, itemId){
      /* api di eliminazione associazione file articolo alla tipologia */
      if(confirm('Sei sicuro di voler eliminare l\'allegato per il seguente articolo?')){
        var adminItemAttachmentFile = this;
        var data = {
          idAttachmentFile: id,
          idItem: itemId
        };
        itemAttachmentFileServices.deleteFromItemAttachmentFileItem(data, function (result) {
          console.log(result);
          console.log(adminItemAttachmentFile.modalAllegati);
          notificationHelpers.success('Eliminazione avvenuta con successo!');
        })
      }
    }
    /* end popup documenti */
  }
};
</script>
<style>

.card-title-admin h1{
  font-size:40px;
  font-weight: lighter;
  color:#303C54;
}
.align-btn {
  position: absolute;
  margin-top: 30px;
  margin-left: 5px;
  z-index: 1;
}

.container-no-categories-item {
  /*min-height: 98%;
  max-height: 98%;*/
  overflow-x: hidden;
  padding-top: 15px;
  padding-bottom: 15px;
}
.container-no-categories-item label{
  margin-bottom: 5px !important;
}

.container-fluid label{
  font-weight:normal !important;
  font-size:15px !important;
}

.div-row-img-item img {
  max-height: 100px;
}
.div-row-img-item label {
  color: #303c54;
  font-size: 14px;
  font-weight: lighter;
}
.div-row-img-item {
  padding-top: 10px;
  padding-bottom: 10px;
}

/* style for upload area */
#imgPrincipal[type="file"] {
  display: none;
}
#imgPrincipalAgg[type="file"] {
  display: none;
}
.imgAttachmentAgg[type="file"] {
  display: none;
}
.custom-file-upload {
  padding: 20px;
  cursor: pointer;
  width: 100%;
  text-align: center;
  border: 3px dashed #ededed;
  border-radius: 10px;
}
/* end style for upload area */

#accordionExample .card-header{
  padding:5px;
}
#accordionExample .btn-link{
  color: #222;
    padding: 0px;
    font-weight: bold;
}
#accordionExample h5{
  font-size:15px;
  margin-bottom: 0px;
}
#accordionExample .card-body{
  padding:10px;
}


</style>
